import React from 'react'

const NoRecord = () => {
  return (
    <h3 className="text-center ct_no_record_found ct_py_70">
      No record found.
    </h3>
  );
}

export default NoRecord
